import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rawTerms from "@living/terms-of-service.md?raw";
import { stripInternalAnnotations } from "@/lib/strip-flag-callouts";
import { LegalPageLayout } from "@/components/legal/LegalPageLayout";
import { Seo } from "@/components/public/Seo";

export default function TermsOfService() {
  const cleaned = stripInternalAnnotations(rawTerms);
  return (
    <LegalPageLayout>
      <Seo path="/terms-of-service" />
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{cleaned}</ReactMarkdown>
    </LegalPageLayout>
  );
}
